import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ConnectionStatusIcon from '../shared/ConnectionStatusIcon';
import { useSiteConfigContext } from '../../contexts/SiteConfigContext';

import config from '../../config.json';
import { Typography } from '@mui/material';

import { useClerk } from '@clerk/clerk-react';
import { useAuth, UserButton } from '@clerk/clerk-react';
import { ClerkAccountSkin, ClerkSignInSkin } from './ClerkSkins';
// ADDED — custom user button for comparison
import JernyUserButton from '../JernyUserComponents/JernyUserButton';

/**
 * AppBar action buttons — sign in/up or user button + connection status.
 */
export default function AppBarActions() {
    const { isSignedIn } = useAuth();
    const { openSignIn } = useClerk();
    const siteConfig = useSiteConfigContext();

    if (!isSignedIn) {
        return (
            <Box sx={{ display: 'flex', gap: 1 }}>
                {siteConfig?.loginActive && (
                    <Button
                        variant="text"
                        size="small"
                        onClick={() => openSignIn(ClerkSignInSkin)}
                        sx={{
                            color: '#a3d1ff',
                            textTransform: 'none',
                            '&:hover': { bgcolor: 'rgba(102, 178, 255, 0.08)' },
                        }}
                    >
                        Sign in
                    </Button>
                )}
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {config.appMode !== 'PROD' && (
                <Typography sx={{ color: '#a3d1ff' }}>{config.appMode}</Typography>
            )}

            <ConnectionStatusIcon />

            {/* ADDED — custom user button next to Clerk for comparison */}
            <JernyUserButton />
            {/* <UserButton userProfileUrl="/dashboard" appearance={ClerkAccountSkin} /> */}
        </Box>
    );
}
